import { render, staticRenderFns } from "./Trade-Terms.vue?vue&type=template&id=3ff59dba&scoped=true"
import script from "./Trade-Terms.vue?vue&type=script&lang=js"
export * from "./Trade-Terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff59dba",
  null
  
)

export default component.exports